import React, { useState, useCallback } from "react";
import { debounce } from "lodash";
import { Controller } from "react-hook-form";
import BaseAutocomplete from "components/Shared/Base/BaseAutocomplete";
import { useLazySearchVendorsQuery } from "store/services/vendorProfileApi";

const SearchVendor = ({
  control,
  name,
  label,
  required = false,
  disabled = false,
  error = false,
  helperText = "",
  accountId,
  entityId,
  isVendorView = false,
  minLength = 3,
  onChange = () => { },
  onAddNew = () => { },
}) => {
  const [searchVendors, { isLoading: loadingVendors }] =
    useLazySearchVendorsQuery();
  const [vendorSearchResults, setVendorSearchResults] = useState([]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSearchVendors = useCallback(
    debounce(async (query) => {
      if (query && query.length >= minLength && accountId && entityId) {
        const result = await searchVendors({ account: accountId, entity: entityId, query }).unwrap();
        setVendorSearchResults(result?.data || []);
      } else {
        setVendorSearchResults([]);
      }
    }, 300),
    [accountId, entityId, searchVendors, minLength]
  );

  return (
    <Controller
      name={name}
      control={control}
      rules={required ? { required: "Please select a vendor profile." } : {}}
      render={({ field }) => (
        <BaseAutocomplete
          fullWidth
          required={required}
          label={label}
          value={field.value || null}
          onChange={(_, data) => {
            field.onChange(data);
            onChange(data);
          }}
          onInputChange={(event, newInputValue) => {
            debouncedSearchVendors(newInputValue);
          }}
          getOptionLabel={(option) =>
            option
              ? isVendorView
                ? `${option?.ownerName} - ${option?.phone}`
                : `${option?.ownerName} - ${option?.shopName}`
              : ""
          }
          isOptionEqualToValue={(option, value) => option?._id === value?._id}
          options={vendorSearchResults || []}
          loading={loadingVendors}
          loadingText="Searching Vendors..."
          disabled={disabled}
          helperText={helperText}
          error={error}
          noOptionsText="Enter at least 3 charaters to search Vendor Profile"
          getOptionKey={(option) => option._id}
          PaperComponent={(props) => (
            <BaseAutocomplete.PaperAddNew
              {...props}
              buttonLabel="Add Vendor Profile"
              onAddNew={onAddNew}
            />
          )}
        />
      )}
    />
  );
};

export default SearchVendor;